export function normalizeNumericDraft(value, { decimals = 2, allowNegative = false } = {}) {
  const raw = String(value ?? '').replace(/\s/g, '');
  const sign = allowNegative ? '-?' : '';
  const fraction = decimals > 0 ? `(?:[.,]\\d{0,${decimals}})?` : '';
  const pattern = new RegExp(`^${sign}\\d*${fraction}$`);
  return pattern.test(raw) ? raw : null;
}

export function parseNumericDraft(value, { decimals = 2, allowNegative = false, min, max } = {}) {
  const normalized = normalizeNumericDraft(value, { decimals, allowNegative });
  if (normalized === null || normalized === '' || normalized === '-' || /[.,]$/.test(normalized)) {
    return { ok: false, value: null };
  }
  const parsed = Number(normalized.replace(',', '.'));
  if (!Number.isFinite(parsed) || (min !== undefined && parsed < min) || (max !== undefined && parsed > max)) {
    return { ok: false, value: null };
  }
  return { ok: true, value: parsed };
}

export function acceptNumericDraft(event, onChange, options) {
  const next = normalizeNumericDraft(event.target.value, options);
  if (next !== null) onChange(next);
}
